import { defineStore } from "pinia";
import { ref } from "vue";
import type { DocumentItem } from "~/stores/documents/types";

export const useDocumentsStore = defineStore("documents", () => {
  const documents: Ref<DocumentItem[]> = ref<DocumentItem[]>([]);

  async function fetchDocuments () {
    const data: any = await $fetch(`${useRuntimeConfig().public.api_host}api/documents`);
    return documents.value = data;
  }

  function getPolicyDocumentUrl(): string|null {
    const doc: DocumentItem|undefined = documents.value.find((doc: DocumentItem): boolean => doc.is_pdp);
    return !doc ? null : doc.url;
  }

  return { documents, fetchDocuments, getPolicyDocumentUrl };
});
